export default __webpack_public_path__ + "static/media/trunk.399c1400.png";